import {
  pickFormFillOnAccentText,
  resolveFormFillAccent,
} from "@/app/(dashboard)/_components/forms/fill/form-fill-accent";

export interface AuthAccent {
  readonly accent: string;
  readonly accentText: string;
  readonly accentShadow: string;
}

function hexToRgb(hex: string): { r: number; g: number; b: number } {
  const match = /^#?([0-9a-fA-F]{6})$/.exec(hex.trim());
  const n = match?.[1] ? Number.parseInt(match[1], 16) : 0x008070;
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

/** Same brand accent as the portal sign-in, so forgot/reset keep the org look. */
export function portalAuthAccent(brandColor: string | null): AuthAccent {
  const accent = resolveFormFillAccent(brandColor ?? "");
  const { r, g, b } = hexToRgb(accent);
  return {
    accent,
    accentText: pickFormFillOnAccentText(accent),
    accentShadow: `rgba(${r}, ${g}, ${b}, 0.5)`,
  };
}
